module.exports = __webpack_public_path__ + "313824e85557a721d326424b6eb63fec.woff2";